export const telegramUpdateAccountPhotoModalName = 'telegram-update-account-photo';
